module.exports = __webpack_public_path__ + "static/media/rotate-clockwise-icon.9dd0f0b6.png";